import {useLocalStorageValue} from '@react-hookz/web';
import {clsx} from 'clsx';
import {InitData} from '../../../common/init-data/init-data';
import {NumberHelper} from '../../../helper/number-helper';

export type EvStatusLabelType =
  'workflow_status' |
  'offer' |
  'order_status' |
  'request_status' |
  'fetch_status' |
  'invoice_status' |
  'business_order_status';

interface Props {
  type: EvStatusLabelType;
  state?: string | number | null;
  additional?: string | null;
  className?: string;
}

export function EvStatusLabel(props: Props) {
  const initData = useLocalStorageValue<InitData>('data');
  const id = NumberHelper.saveParseInteger(props.state);
  const state = id === null ? undefined : initData.value?.[props.type]?.[id];
  if (!state) {
    return null;
  }

  return <span className={clsx('label', `label-${state.label}`, props.className)}>
    {props.additional ? `${state.name} ${props.additional}` : state.name}
  </span>;
}
